import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomDateFormatPipe],
  selector: 'app-bn-alert-notice',
  templateUrl: './bn-alert-notice.component.html',
  styleUrls: ['./bn-alert-notice.component.scss']
})
export class BnAlertNoticeComponent {
  hideAlert : boolean;
  
  @Input()  autoPayAlert: boolean;
  @Input() policy: any;
  @Input() deductionDay: string;
  paymentMessage: boolean;
  

  constructor() {
    this.hideAlert = false;
   }

  onClose() {
    this.hideAlert = true;
  }

}
